import {useEffect, useState} from 'react';

const useModeSetting = () => {
    const [mode, setMode] = useState('light');

    useEffect(() => {
        const savedMode = sessionStorage.getItem('data-layout-mode');
        if (savedMode) {
            setMode(savedMode);
            document.body.setAttribute('data-mode', savedMode);
        } else {
            // Automatically set light mode if nothing is saved
            document.body.setAttribute('data-mode', 'light');
            sessionStorage.setItem('data-layout-mode', 'light');
        }
    }, []);

    return mode;
};

export default useModeSetting;
